const data = {
  type: "FeatureCollection",
  totalFeatures: 1,
  features: [],
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:EPSG::4326" } }
};

export default data;
